import { createSelector } from 'reselect';

import { selectGroup } from 'services/groups/selectors';
import { makeSelectGroupPeopleIds } from 'services/groupPeople/selectors';
import { makeSelectGroupEntitiesIds } from 'services/groupEntities/selectors';

const selectGroupId = (state, props) => props.groupId;
const selectDefaultValues = (state, props) => props.defaultValues;

const selectInitialValues = createSelector(
    [
        selectGroup,
        selectGroupId,
        selectDefaultValues,
        makeSelectGroupPeopleIds(),
        makeSelectGroupEntitiesIds()
    ],
    (
        groupState,
        groupIdState,
        defaultValuesState,
        personIdsState,
        entityIdsState
    ) => {
        if (defaultValuesState) {
            const {
                personIds,
                entityIds,
                color,
                ...defaultValues
            } = defaultValuesState;
            return {
                ...defaultValues,
                color: color || undefined,
                personIds: personIds && personIds.map(Number),
                entityIds: entityIds && entityIds.map(Number)
            };
        }

        if (!groupIdState) return undefined;

        if (groupState) {
            return {
                name: groupState.name,
                color: groupState.color,
                personIds: personIdsState,
                entityIds: entityIdsState
            };
        }

        return undefined;
    }
);

export { selectInitialValues };
